import React, { useState, useEffect } from 'react'
import { getMoscowProgressBatch } from '../lib/api'

const REGIONS = ['АФРИКА', 'АЗИЯ', 'ЛАТАМ', 'МОСКВА']

const TOTAL_TASKS = 24

function progressColor(pct) {
  if (pct >= 71) return '#639922'
  if (pct >= 31) return '#EF9F27'
  return '#bbb'
}

function hasMskTicketAuto(c) {
  const route = Array.isArray(c.route) ? c.route : (typeof c.route === 'string' ? (() => { try { return JSON.parse(c.route) } catch { return [] } })() : [])
  return route.some(seg => seg.to && seg.to.toLowerCase().includes('москв') && !seg.is_return)
}

export default function Board({ locations, candidates, statusColors, onMoveCandidate, onAddCandidate, onEditLocation, onAddLocation, onClickCandidate, onUpdateCandidate, isViewer, isAdmin, isOperator, onReorderLocations, currentUserId }) {
  const [activeRegion, setActiveRegion] = useState('АФРИКА')
  const [search, setSearch] = useState('')
  const [onlyMine, setOnlyMine] = useState(false)
  const [locFilter, setLocFilter] = useState(new Set())
  const [showLocFilter, setShowLocFilter] = useState(false)
  const [responsibleFilter, setResponsibleFilter] = useState('')
  const [visaFilter, setVisaFilter] = useState('')
  const [mskFilter, setMskFilter] = useState(false)
  const [moscowProgress, setMoscowProgress] = useState({})

  const regionLocations = locations.filter(l => {
    if ((l.region || 'АФРИКА') !== activeRegion) return false
    if (locFilter.size > 0 && !locFilter.has(l.id)) return false
    return true
  })
  const responsibleNames = [...new Set(candidates.map(c => c.responsible_name).filter(Boolean))].sort()

  const filteredCandidates = candidates.filter(c => {
    if (onlyMine && c.responsible_id !== currentUserId) return false
    if (isAdmin && responsibleFilter && c.responsible_name !== responsibleFilter) return false
    if (isAdmin && visaFilter) {
      const visas = c.visas || []
      const botCountry = (c.bot_visa_country || '').toLowerCase()
      const hasSpec = visas.some(v => v.name?.toLowerCase().includes('спец')) || botCountry.includes('спец') || !!c.specvisa_sent_at
      const hasEvisa = visas.some(v => v.name?.toLowerCase().includes('e-visa') || v.name?.toLowerCase().includes('е-виза')) || botCountry.includes('e-visa') || botCountry.includes('е-виза')
      const hasRf = visas.some(v => { const n = v.name || ''; return (n.includes('РФ') || n.includes('Россия')) && !n.toLowerCase().includes('спец') && !n.toLowerCase().includes('e-visa') }) ||
        ((botCountry.includes('рф') || botCountry.includes('россия')) && !botCountry.includes('спец') && !botCountry.includes('e-visa'))
      const hasEthiopia = visas.some(v => v.name?.toLowerCase().includes('эфиопи') || v.name?.toLowerCase().includes('ефиопи')) || botCountry.includes('эфиопи') || botCountry.includes('ефиопи')
      if (visaFilter === 'visa_45plus') {
        const submittedV = (c.visas || []).find(v => v.submission_date)
        const vd = c.specvisa_sent_at || c.tourvisa_sent_at || (submittedV && submittedV.submission_date) || c.bot_visa_date || null
        const days = vd && !c.visa_issued_at && !c.visa_received_at ? Math.floor((Date.now() - new Date(vd).getTime()) / 86400000) : null
        if (!days || days < 45) return false
      }
      if (visaFilter === 'peter_submitted' && !c.peter_visa_submitted_at) return false
      if (visaFilter === 'sv_submitted' && !(hasSpec && !c.visa_issued_at && !c.visa_received_at)) return false
      if (visaFilter === 'sv_issued' && !(c.visa_issued_at && !c.visa_received_at)) return false
      if (visaFilter === 'sv_received' && !c.visa_received_at) return false
      if (visaFilter === 'spec_yes' && !hasSpec) return false
      if (visaFilter === 'spec_no' && hasSpec) return false
      if (visaFilter === 'evisa_yes' && !hasEvisa) return false
      if (visaFilter === 'evisa_no' && hasEvisa) return false
      if (visaFilter === 'rf_yes' && !hasRf) return false
      if (visaFilter === 'rf_no' && hasRf) return false
      if (visaFilter === 'ethiopia_yes' && !hasEthiopia) return false
      if (visaFilter === 'ethiopia_no' && hasEthiopia) return false
    }
    if (mskFilter && !hasMskTicketAuto(c) && !c.has_msk_ticket) return false
    if (!search) return true
    const q = search.toLowerCase()
    const locName = locations.find(l => l.id === c.location_id)?.name || ''
    return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q) || locName.toLowerCase().includes(q) || c.city?.toLowerCase().includes(q)
  })

  const visaPriority = (c) => {
    if (c.visa_received_at) return 3
    if (c.visa_issued_at) return 2
    const submittedVisa = (c.visas || []).find(v => v.submission_date)
    const hasVisa = !!(submittedVisa || c.bot_visa_date || c.specvisa_sent_at || c.tourvisa_sent_at)
    if (hasVisa) return 1
    return 0
  }

  const getCandidatesForLocation = (locId) =>
    filteredCandidates.filter(c => c.location_id === locId)
      .sort((a, b) => {
        const vp = visaPriority(b) - visaPriority(a)
        if (vp !== 0) return vp
        return new Date(b.created_at || 0) - new Date(a.created_at || 0)
      })

  useEffect(() => {
    if (activeRegion !== 'МОСКВА') return
    const moscowLocs = locations.filter(l => (l.region || 'АФРИКА') === 'МОСКВА')
    const ids = candidates
      .filter(c => moscowLocs.some(l => l.id === c.location_id))
      .map(c => c.id)
    if (!ids.length) return
    getMoscowProgressBatch(ids).then(setMoscowProgress).catch(() => {})
  }, [activeRegion, candidates, locations])

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {REGIONS.map(region => (
          <button key={region} onClick={() => setActiveRegion(region)} style={{
            fontSize: 13, padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
            background: activeRegion === region ? '#1a1a1a' : '#e8e8e5',
            color: activeRegion === region ? 'white' : '#444',
            fontWeight: activeRegion === region ? 600 : 400
          }}>
            {region === 'АФРИКА' ? '🌍' : region === 'АЗИЯ' ? '🌏' : region === 'ЛАТАМ' ? '🌎' : '🏛'} {region}
            <span style={{ marginLeft: 6, fontSize: 11, opacity: 0.7 }}>
              {filteredCandidates.filter(c => locations.find(l => l.id === c.location_id)?.region === region).length}
            </span>
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        {/* Кнопки-переключатели */}
        {currentUserId && (
          <button onClick={() => setOnlyMine(v => !v)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 8, border: '1px solid ' + (onlyMine ? '#1a1a1a' : '#e0e0dc'), background: onlyMine ? '#1a1a1a' : 'white', color: onlyMine ? 'white' : '#444', cursor: 'pointer', fontWeight: onlyMine ? 600 : 400 }}>
            👤 Только мои
          </button>
        )}
        <div style={{ position: 'relative' }} onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) setShowLocFilter(false) }} tabIndex={-1}>
          <button onClick={() => setShowLocFilter(v => !v)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 8, border: '1px solid ' + (locFilter.size > 0 ? '#1a1a1a' : '#e0e0dc'), background: locFilter.size > 0 ? '#1a1a1a' : 'white', color: locFilter.size > 0 ? 'white' : '#444', cursor: 'pointer' }}>
            🏙 Города {locFilter.size > 0 ? `(${locFilter.size})` : ''}
          </button>
          {showLocFilter && (
            <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: 4, background: 'white', border: '1px solid #e0e0dc', borderRadius: 10, padding: '10px 14px', zIndex: 100, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', minWidth: 200, maxHeight: 300, overflowY: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, fontSize: 11 }}>
                <span style={{ color: '#888' }}>Фильтр городов</span>
                {locFilter.size > 0 && <button onClick={() => setLocFilter(new Set())} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E24B4A', fontSize: 11 }}>Сбросить</button>}
              </div>
              {locations.filter(l => (l.region || 'АФРИКА') === activeRegion).map(l => (
                <label key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 13, cursor: 'pointer' }}>
                  <input type="checkbox" checked={locFilter.has(l.id)} onChange={e => {
                    setLocFilter(prev => { const n = new Set(prev); e.target.checked ? n.add(l.id) : n.delete(l.id); return n })
                  }} />
                  {l.icon} {l.name}
                  <span style={{ marginLeft: 'auto', fontSize: 11, color: '#aaa' }}>{candidates.filter(c => c.location_id === l.id).length}</span>
                </label>
              ))}
            </div>
          )}
        </div>
        <button onClick={() => setMskFilter(v => !v)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 8, border: '1px solid ' + (mskFilter ? '#16A34A' : '#e0e0dc'), background: mskFilter ? '#16A34A' : 'white', color: mskFilter ? 'white' : '#444', cursor: 'pointer', fontWeight: mskFilter ? 600 : 400 }}>
          ✈ Билет в МСК
        </button>
        {/* Разделитель */}
        {isAdmin && <div style={{ width: 1, height: 20, background: '#e0e0dc', flexShrink: 0 }} />}
        {/* Дропдауны */}
        {isAdmin && responsibleNames.length > 0 && (
          <select value={responsibleFilter} onChange={e => setResponsibleFilter(e.target.value)}
            style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: '1px solid ' + (responsibleFilter ? '#1a1a1a' : '#e0e0dc'), background: responsibleFilter ? '#1a1a1a' : 'white', color: responsibleFilter ? 'white' : '#444', cursor: 'pointer' }}>
            <option value="">👤 Ответственный</option>
            {responsibleNames.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        )}
        {isAdmin && (
          <select value={visaFilter} onChange={e => setVisaFilter(e.target.value)}
            style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: '1px solid ' + (visaFilter ? '#1a1a1a' : '#e0e0dc'), background: visaFilter ? '#1a1a1a' : 'white', color: visaFilter ? 'white' : '#444', cursor: 'pointer' }}>
            <option value="">📄 Визы</option>
            <option value="visa_45plus">⚠️ Виза 45+ дней</option>
            <option value="peter_submitted">✈️ Питер: подана</option>
            <option value="sv_submitted">🛂 Спецвиза подана</option>
            <option value="sv_issued">📬 Виза вышла</option>
            <option value="sv_received">✅ Виза получена</option>
            <option value="spec_yes">Спецвиза: есть</option>
            <option value="spec_no">Спецвиза: нет</option>
            <option value="evisa_yes">Е-виза: есть</option>
            <option value="evisa_no">Е-виза: нет</option>
            <option value="rf_yes">РФ виза: есть</option>
            <option value="rf_no">РФ виза: нет</option>
            <option value="ethiopia_yes">Эфиопия: есть</option>
            <option value="ethiopia_no">Эфиопия: нет</option>
          </select>
        )}
        {(onlyMine || locFilter.size > 0 || responsibleFilter || visaFilter || mskFilter) && (
          <button onClick={() => { setOnlyMine(false); setLocFilter(new Set()); setResponsibleFilter(''); setVisaFilter(''); setMskFilter(false) }} style={{ fontSize: 11, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', color: '#888', cursor: 'pointer' }}>✕ Сбросить всё</button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
        {regionLocations.map(loc => {
          const locCandidates = getCandidatesForLocation(loc.id)
          return (
            <div key={loc.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0ec', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafaf8' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 16 }}>{loc.icon || '📍'}</span>
                  <span style={{ fontWeight: 600, fontSize: 13 }}>{loc.name}</span>
                  <span style={{ fontSize: 11, color: '#aaa' }}>{locCandidates.length}</span>
                </div>
                {isAdmin && (
                  <button onClick={() => onEditLocation(loc)} style={{ fontSize: 11, color: '#aaa', background: 'transparent', border: 'none', cursor: 'pointer' }}>✏</button>
                )}
              </div>
              <div style={{ padding: 8, minHeight: 60 }}>
                {locCandidates.length === 0 && (
                  <div style={{ fontSize: 11, color: '#ccc', textAlign: 'center', padding: '12px 0' }}>Нет кандидатов</div>
                )}
                {locCandidates.map(c => {
                  const prog = moscowProgress[c.id]
                  const pct = prog ? Math.round(prog.done / TOTAL_TASKS * 100) : null
                  const submittedVisa = (c.visas || []).find(v => v.submission_date)
                  const specvisaDate = c.specvisa_sent_at
                    ? new Date(c.specvisa_sent_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow' })
                    : null
                  const visaDate = submittedVisa
                    ? submittedVisa.submission_date.slice(5).split('-').reverse().join('.')
                    : c.bot_visa_date
                      ? c.bot_visa_date.replace(/^(\d{2})\.(\d{2}).*$/, '$1.$2')
                      : specvisaDate
                  const hasVisa = !!(submittedVisa || c.bot_visa_date || c.specvisa_sent_at || c.tourvisa_sent_at)
                  const tourvisaDate = c.tourvisa_sent_at
                    ? new Date(c.tourvisa_sent_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow' })
                    : null
                  const visaReceivedDate = c.visa_received_at
                    ? new Date(c.visa_received_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow' })
                    : null
                  const visaIssuedDate = c.visa_issued_at
                    ? new Date(c.visa_issued_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow' })
                    : null
                  const isTourVisa = !c.specvisa_sent_at && !submittedVisa && !c.bot_visa_date && !!c.tourvisa_sent_at
                  const peterVisaDate = c.peter_visa_submitted_at
                    ? new Date(c.peter_visa_submitted_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow' })
                    : null
                  const visaSubmittedDate = c.specvisa_sent_at || c.tourvisa_sent_at || (submittedVisa && submittedVisa.submission_date) || c.bot_visa_date || null
                  const visaDaysAgo = visaSubmittedDate && !c.visa_issued_at && !c.visa_received_at
                    ? Math.floor((Date.now() - new Date(visaSubmittedDate).getTime()) / 86400000)
                    : null
                  const isVisa45Plus = visaDaysAgo !== null && visaDaysAgo >= 45
                  const cardBorderColor = c.visa_received_at ? '#6a1b9a' : c.visa_issued_at ? '#e65100' : c.peter_visa_submitted_at ? '#ef5350' : isVisa45Plus ? '#f5c800' : hasVisa ? (isTourVisa ? '#2e6da4' : '#0A7C5C') : null
                  const cardBorderStyle = cardBorderColor ? `3px solid ${cardBorderColor}` : '1px solid #efefec'
                  const mskAuto = hasMskTicketAuto(c)
                  const mskManual = !!c.has_msk_ticket
                  const showMskBadge = mskAuto || mskManual
                  return (
                    <div key={c.id} onClick={() => onClickCandidate(c)} className="board-candidate-card" style={{ padding: '8px 10px', borderRadius: 8, marginBottom: 6, cursor: 'pointer', background: '#f9f9f7', border: cardBorderColor ? `1px solid ${cardBorderColor}` : '1px solid #efefec', borderLeft: cardBorderStyle, transition: 'background 0.15s' }}
                      onMouseOver={e => e.currentTarget.style.background = '#f0f0ec'}
                      onMouseOut={e => e.currentTarget.style.background = '#f9f9f7'}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        {c.photo_url && <img src={c.photo_url} alt={c.name} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}{isAdmin && c.is_restricted && <span title="Скрыт от ограниченных" style={{ marginLeft: 5, fontSize: 10, color: '#E24B4A', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 3, padding: '1px 4px', fontWeight: 500 }}>скрыт</span>}</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                            <div style={{ width: 6, height: 6, borderRadius: '50%', background: statusColors[c.status] || '#aaa', flexShrink: 0 }} />
                            <span style={{ fontSize: 10, color: '#888' }}>{c.status}</span>
                          </div>
                          {c.visa_received_at && (
                            <div style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#f3e5f5', color: '#6a1b9a', fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 4px', borderRadius: 8, border: '1px solid rgba(106,27,154,.25)', lineHeight: 1 }}>
                              <span style={{ fontSize: 11 }}>✅</span> Виза получена · {visaReceivedDate}
                            </div>
                          )}
                          {!c.visa_received_at && c.visa_issued_at && (
                            <div style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#fff3e0', color: '#e65100', fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 4px', borderRadius: 8, border: '1px solid rgba(230,81,0,.25)', lineHeight: 1 }}>
                              <span style={{ fontSize: 11 }}>📬</span> Виза вышла · {visaIssuedDate}
                            </div>
                          )}
                          {!c.visa_received_at && !c.visa_issued_at && hasVisa && !isTourVisa && (
                            <div style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#e6f4f0', color: '#0A7C5C', fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 4px', borderRadius: 8, border: '1px solid rgba(10,124,92,.2)', lineHeight: 1 }}>
                              <span style={{ fontSize: 11 }}>🛂</span> Виза подана · {visaDate}
                            </div>
                          )}
                          {!c.visa_received_at && !c.visa_issued_at && isTourVisa && (
                            <div style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#e8f0fe', color: '#2e6da4', fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 4px', borderRadius: 8, border: '1px solid rgba(46,109,164,.25)', lineHeight: 1 }}>
                              <span style={{ fontSize: 11 }}>🌍</span> ТВ {tourvisaDate}{c.tourvisa_embassy ? ' · ' + c.tourvisa_embassy : ''}
                            </div>
                          )}
                          {isVisa45Plus && (
                            <div style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#fffbe6', color: '#7a5f00', fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 4px', borderRadius: 8, border: '1px solid rgba(245,200,0,.5)', lineHeight: 1 }}>
                              <span style={{ fontSize: 11 }}>⚠️</span> Виза {visaDaysAgo}+ дней
                            </div>
                          )}
                          {c.peter_visa_submitted_at && (
                            <div style={{ marginTop: 4, display: 'inline-flex', alignItems: 'center', gap: 3, background: '#fdecea', color: '#b71c1c', fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 4px', borderRadius: 8, border: '1px solid rgba(239,83,80,.35)', lineHeight: 1 }}>
                              <span style={{ fontSize: 11 }}>✈️</span> Виза подана · ПИТЕР · {peterVisaDate}
                            </div>
                          )}
                          {pct !== null && (
                            <div style={{ marginTop: 5 }}>
                              <div style={{ height: 3, borderRadius: 2, background: '#efefec', overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: pct + '%', background: progressColor(pct), borderRadius: 2, transition: 'width 0.4s' }} />
                              </div>
                              <div style={{ fontSize: 9, color: '#aaa', marginTop: 2 }}>{prog.done}/{TOTAL_TASKS} задач оформления</div>
                            </div>
                          )}
                          <div style={{ marginTop: 5, display: 'flex', alignItems: 'center', gap: 6 }}>
                            {showMskBadge && (
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 10, fontWeight: 600, padding: '2px 7px 2px 5px', borderRadius: 20, border: '1px solid', lineHeight: 1, background: mskAuto ? '#DCFCE7' : '#FEF3C7', color: mskAuto ? '#16A34A' : '#D97706', borderColor: mskAuto ? '#BBF7D0' : '#FDE68A' }}>
                                ✈ Билет в МСК
                              </span>
                            )}
                            {!isViewer && onUpdateCandidate && !mskFilter && (
                              <span
                                title={mskManual ? 'Снять отметку «Билет в МСК»' : 'Отметить «Билет в МСК» вручную'}
                                onClick={e => { e.stopPropagation(); onUpdateCandidate(c.id, { has_msk_ticket: !mskManual }) }}
                                style={{ fontSize: 10, color: mskManual ? '#D97706' : '#bbb', cursor: 'pointer', userSelect: 'none', padding: '2px 4px', borderRadius: 4, transition: 'color 0.15s' }}
                                onMouseOver={e => e.currentTarget.style.color = '#D97706'}
                                onMouseOut={e => e.currentTarget.style.color = mskManual ? '#D97706' : '#bbb'}
                              >
                                {mskManual ? '✈✓' : '✈+'}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
        {(isAdmin || isOperator) && (
          <div onClick={() => onAddLocation(activeRegion)} style={{ border: '2px dashed #e0e0dc', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 80, cursor: 'pointer', color: '#bbb', fontSize: 13 }}>
            + Локация
          </div>
        )}
      </div>
    </div>
  )
}
